import { Reducer } from "redux";
import { GlobalNavigationAccentAction } from "./actions";

// userId ごとのアクセント状態
interface UserAccentState {
  isClosed: boolean;
}

interface Accent {
  path: string;
  message: string;
  // アクセント全体の有効期限（固定）
  expiresAt: number;
  // userId ごとに「閉じた状態」を管理
  byUserId: { [userId: string]: UserAccentState };
}

interface GlobalNavigationAccentState {
  accents: Accent[];
}

// 2026/7/23 23:59:59 (JST) まで
const STRATEGY_SCANNER_EXPIRES_AT = new Date(
  "2026-07-23T23:59:59+09:00"
).getTime();

const initialState: GlobalNavigationAccentState = {
  accents: [
    {
      path: "/strategy-scanner",
      message: "「経営戦略スキャナー」が\n追加されました",
      expiresAt: STRATEGY_SCANNER_EXPIRES_AT,
      byUserId: {}
    }
  ]
};

export const globalNavigationAccent: Reducer<
  GlobalNavigationAccentState,
  GlobalNavigationAccentAction
> = (state = initialState, action) => {
  switch (action.type) {
    case "globalNavigationAccent/close": {
      const { path, userId } = action.payload;
      return {
        ...state,
        accents: state.accents.map(accent =>
          accent.path === path
            ? {
                ...accent,
                byUserId: {
                  ...accent.byUserId,
                  [userId]: { isClosed: true }
                }
              }
            : accent
        )
      };
    }
    default:
      return state;
  }
};
